import Overlay from "../../../Componentes/Overlay";
import Modal from "../../../Componentes/Utils/Modal";
import { useModal } from "../../../contexts/ModalContext"
import Formulario from "../../../Componentes/Utils/Formulario";
import FormComp from "../../../Componentes/FormComp";
import { useEffect, useState } from "react";
import styled from "styled-components";

import useApi from "../../../hooks/useApi";
const Titulo = styled.h3`
    margin: 5px auto;
    text-align: center;
    color: #000;
    font-size: 15px;
`

const ModalAddConteudo = ({ modo, item = null, parentId = null, onSuccess, treinamentoId }) => {
    const api = useApi();


    const { closeModal } = useModal();

    const [conteudo, setConteudo] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (modo === "edit" && item) {
            setConteudo(item.conteudo ?? "");
        }
    }, [modo, item]);

    const handleSubmit = async (e) => {

        e.preventDefault();
        setLoading(true);

        try {

            const formData = new FormData();
            formData.append("conteudo", conteudo);
            formData.append("treinamentoId", treinamentoId);

            if (modo === "edit" && item) {

                formData.append("id", item.id);

            }

            if (parentId) {

                formData.append("parentId", parentId);

            }

            const url = "/Painel/API/Treinamentos/SalvarConteudo/";
            const { data } = await api.post(url, formData, { withCredentials: true });
            console.log(data);

            if (onSuccess) onSuccess();
            closeModal();

        } catch (error) {

            console.error("Erro ao salvar conteúdo:", error);
            alert("Erro ao salvar conteúdo. Tente novamente.");

        } finally {

            setLoading(false);

        }

    }

    const titulo = modo === "edit" ? "EDITAR CONTEÚDO" : "ADICIONAR CONTEÚDO";

    return (
        <Overlay state={true} >
            <Modal close={closeModal} header={true} size="md" >
                <Titulo>{titulo}{item ? ` - ${item.numero}` : ""}</Titulo>
                <Formulario onSubmit={(e) => handleSubmit(e)}>
                    <FormComp
                        title="CONTEÚDO"
                        type="text"
                        valor={conteudo}
                        changeFunc={(e) => setConteudo(e.target.value)}
                    />
                    <FormComp type="submit" valor={loading ? "SALVANDO..." : "SALVAR"} />
                </Formulario>
            </Modal>
        </Overlay>
    )

}

export default ModalAddConteudo;